import { IUser } from '../../types/redux/user';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EActionTypes {
  SET_USER_DATA = 'user/SetUserData',
}

export const setUserData = actionGenerator<EActionTypes.SET_USER_DATA, IUser>(EActionTypes.SET_USER_DATA);

export type TUserActions = ReturnType<typeof setUserData>;
